import { LinkOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import DrawerButton from 'components/Views/Creative/Drawers/DrawerButton';
import type Bundle from 'stores/Bundle';

export interface GetBundleDownloadLinkButtonProps {
  bundle: Bundle;
}

function GetBundleDownloadLinkButton({
  bundle,
}: GetBundleDownloadLinkButtonProps) {
  const copyDownloadUrlToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(bundle.downloadURL);
      void message.success('Link to Bundle ZIP copied.');
    } catch (error) {
      void message.error('Failed to copy link to Bundle ZIP: ' + error);
    }
  };

  return (
    <DrawerButton
      disabled={bundle.loading}
      onClick={copyDownloadUrlToClipboard}
    >
      <LinkOutlined />
    </DrawerButton>
  );
}

export default observer(GetBundleDownloadLinkButton);
